var config = {
  // 用户状态
  USER_STATUS: [{
    value: "0",
    label: "正常"
  }, {
    value: "1",
    label: "锁定"
  }],
  // sex
  SEX: [{
    value: 1,
    label: "男"
  }, {
    value: 2,
    label: "女"
  }],
  // 公开
  IS_OPEN: [{
    value: 1,
    label: "公开"
  }, {
    value: 0,
    label: "不公开"
  }],
  // 应用类型
  APP_TYPE: [{
    value: "web",
    label: "web应用"
  }, {
    value: "port",
    label: "接口应用"
  }],
  // 是否
  YES_NO: [{
    value: "1",
    label: "是"
  }, {
    value: "0",
    label: "否"
  }],
  // 手机正则
  TEL_REGEXP: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
};

var getter = function getter(obj, key) {
  if (typeof window[key] === "undefined") {
    window[key] = {};
  }

  for (var i in obj) {
    window[key][i] = obj[i];
  }
};

getter(config, "_const");